import React from 'react'

import LoadingWidget from '@/components/widgets/LoadingWidget'
import { cn } from '@/lib/utils'

export interface LoadingOverlayProps {
  isActive: boolean
  children: React.ReactNode
  className?: string
  showSpinner?: boolean
  spinnerPosition?: 'top' | 'center'
  opaque?: boolean
  onOverlayClick?: () => void
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isActive,
  children,
  className,
  showSpinner = true,
  spinnerPosition = 'center',
  opaque = false,
  onOverlayClick,
}) => {
  function renderSpinner() {
    if (spinnerPosition === 'center') {
      return (
        <div
          className="absolute w-full"
          style={{ top: '50%', transform: 'translateY(-50%)' }}
        >
          <div className="flex justify-center">
            <LoadingWidget />
          </div>
        </div>
      )
    }

    return <LoadingWidget />
  }

  const opacityClass = opaque ? 'opacity-100' : 'opacity-50'

  return (
    <div className={className}>
      {isActive && (
        <div
          className={cn(
            'absolute h-full w-full',
            'bg-white',
            isActive ? opacityClass : '',
          )}
          style={{ zIndex: '2' }}
          onClick={onOverlayClick}
        >
          {showSpinner && renderSpinner()}
        </div>
      )}
      {children}
    </div>
  )
}

export default LoadingOverlay
